module.exports = {"title":"Show Confirmation","yes":"Confirm","no":"Cancel","description":"This Access Code is for ","description2":" and a production of ","description3":"ShowTix4U will automatically deduct your {0}% royalty from ticket proceeds that exceed any license minimums.","description4":"If all information is accurate, please click Confirm. If any information needs to be updated, please contact your DPS Rep.","description5":"Have a great show!"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/DPSModal/locales/en.json
// module id = 1688
// module chunks = 0